import React, { useContext, useEffect } from 'react';

import { toJS } from 'mobx';
import { MobXProviderContext, observer } from 'mobx-react';

import { Dropdown } from 'semantic-ui-react';

import '../../css/reports/ReportDropdown.less';

import { SatCoreRegister } from '../../SatCoreRegistry';

import ReportTableService from '../../services/reports/ReportTableService';
import { getSessionStorageItem } from '../../utils';

const ReportAttributeFiltersDropdown = observer((props) => {
  const { t } = props;

  const {
    reportIdentityManager, reportOverrideManager, reportStandardsManager
  } = useContext(MobXProviderContext);

  /** equivalent to componentDidMount(), i.e. only called after initial render */
  useEffect(() => {
    (async () => {
      reportStandardsManager.setSelectedReportAttributeFilterType(
        getSessionStorageItem('selectedReportAttributeFilterType')
      );
    })();
  }, []);

  const handleChangeDropdown = (_event, { value }) => {
    reportStandardsManager.setSelectedReportAttributeFilterType(value);
    ReportTableService.forceRerenderReportTable();
  };

  const renderReportAttributeFiltersDropdown = () => {
    const { reportInfoClassNames } = reportIdentityManager;

    // TODO remove
    // const reportAttributeFilterTypes = Object.values(REPORT_ATTRIBUTE_FILTER_TYPE).map((dropdownOption) => {
    //   return {
    //     text: t(dropdownOption),
    //     value: dropdownOption
    //   };
    // });
    const reportAttributeFilterTypes = toJS(reportOverrideManager.allowedReportCmapStandardsAttributeFilterTypes) || [];

    return (
      <div className={`report-dropdown report-attribute-filters-dropdown ${reportInfoClassNames}`}>
        <div className='dropdown-label'>
          <div className='text'>
            {t('filterBy')}
          </div>
        </div>
        <Dropdown
          onChange={handleChangeDropdown}
          options={reportAttributeFilterTypes.map((dropdownOption) => {
            return {
              text: t(dropdownOption),
              value: dropdownOption
            };
          })}
          value={reportStandardsManager.selectedReportAttributeFilterType} />
      </div>
    );
  };
  return renderReportAttributeFiltersDropdown();
});
export default ReportAttributeFiltersDropdown;

SatCoreRegister('ReportAttributeFiltersDropdown', ReportAttributeFiltersDropdown);
